import memoizeOne from 'react-utils/memoizeOne';
import { DelayedIntervalScheduler } from '../../../common/scheduler/delayed-interval.scheduler';
import { IdleTaskScheduler } from '../../../common/scheduler/idle-task.scheduler';
import { ImmediateTaskScheduler } from '../../../common/scheduler/immediate-task.scheduler';
import { useEffect, useMemo } from 'react';

/**
 * Returns a scheduler that schedules components to load when the browser is idle
 * or immediately in tests or with a delay in older browsers.
 *
 * Should be instantiated only once per app instance.
 */
const getComponentsScheduler = memoizeOne(() => {
  if (IdleTaskScheduler.isSupported()) {
    // Schedule components to load when the browser is idle
    return new IdleTaskScheduler();
  }
  if ('jasmine' in window) {
    // Schedule components to load immediately in tests
    return new ImmediateTaskScheduler();
  }

  // Schedule components to load with a delay in older browsers
  return new DelayedIntervalScheduler();
});
export const useComponentsScheduler = () => {
  const scheduler = useMemo(() => getComponentsScheduler(), []);
  useEffect(() => {
    scheduler.run();
    return () => {
      scheduler.cancel();
    };
  }, [scheduler]);
  return scheduler;
};